import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message, notification } from 'antd';
import { I18n } from '@aws-amplify/core';
import Api from '@/services/api';

import { CreateRiskCategoryRequest } from '@/components/ui/Inputs/types/request/riskCategory';

export const useCreateRiskCategory = () => {
	const queryClient = useQueryClient();
	return useMutation(
		({ body }: { body: CreateRiskCategoryRequest }) => Api.post('/custom-report/risk-category/create', body),
		{
			onError: (err: any) => {
				notification.error({
					message: I18n.get(err?.response?.data?.message || 'Ops... something happened!')
				});
			},
			onSuccess: () => {
				queryClient.invalidateQueries(['risk_categories']);
				queryClient.invalidateQueries(['risk_categories_list']);
				message.success(I18n.get('Risk category created successfully'));
			}
		}
	);
};
